/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_SUPPLY_CHAIN_LIST = gql`
  query SupplyChainSteps($where: SupplyChainStepWhere) {
    supplyChainSteps(where: $where) {
      traceOutput
      name
      description
      orderedId
      id
      entitledRecipients {
        name
        logo
        id
        email
        description
      }
      entitledComplianceDocsTemplate {
        id
        name
        icon
        description
      }
      digitalRecordTemplate {
        id
        fields
      }
      digitalRecordGuide {
        id
        title
        description
      }
      icon
    }
  }
`;
